import { useIsInsideContainer } from '@vk-hr-tek/ui/hooks';

/** Определить, что приложение встроено в сторонний сервис как виджет
 * @returns {boolean}
 *  */
export const useIsWidget = useIsInsideContainer;
